import { notificationApi } from '../api/consultationApi';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

/**
 * Ask for notification permission and register a push subscription with the
 * backend. Safe to call multiple times. Requires the service worker to be
 * registered (production build only in CRA), so it silently no-ops otherwise.
 */
export async function registerPush() {
  try {
    if (!pushSupported()) return { ok: false, reason: 'unsupported' };

    const registration = await navigator.serviceWorker.ready;
    if (!registration) return { ok: false, reason: 'no-sw' };

    const { data } = await notificationApi.getVapidKey();
    if (!data.enabled || !data.publicKey) return { ok: false, reason: 'server-disabled' };

    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return { ok: false, reason: 'denied' };
    } else if (Notification.permission !== 'granted') {
      return { ok: false, reason: 'denied' };
    }

    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
    }

    await notificationApi.subscribePush(subscription);
    return { ok: true };
  } catch (err) {
    console.warn('[push] registration failed:', err.message);
    return { ok: false, reason: err.message };
  }
}

export async function unregisterPush() {
  try {
    if (!pushSupported()) return;
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await notificationApi.unsubscribePush(subscription.endpoint).catch(() => {});
      await subscription.unsubscribe().catch(() => {});
    }
  } catch (err) {
    console.warn('[push] unsubscribe failed:', err.message);
  }
}
